import { render, staticRenderFns } from "./filter-item.vue?vue&type=template&id=fb4fb412&"
import script from "./filter-item.vue?vue&type=script&lang=js&"
export * from "./filter-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports